import { Button, Grid } from '@material-ui/core'
import Select from '../../../control/select/select'
import { makeStyles } from '@material-ui/styles'
import { FC, MutableRefObject } from 'react'
import { Form as FinalForm, FormProps as FinalFormProps } from 'react-final-form'
import MyTextfield from '../../../control/textfield/textfield'
import useTranslate from '../../../i18n/useTranslate'
import { FormType } from '../../../pages/SettingRECAdd'
import useIRBType from '../../../services/um/lookups/useIRBType'
import { validateEmail, validateEN, validatePhone } from '../../../utilities/validate'
import { FormApi } from 'final-form'

interface FormProps {
    onRefForm?: (form: FormApi<FormType, Partial<FormType>>) => void
    onClickBack: () => void
    initialValues?: FormType
    onSubmit: (values: FormType) => void
    onChangeREC?: (recID: number) => void
}
const Form: FC<FormProps> = ({ onRefForm, onClickBack, initialValues, onSubmit, onChangeREC }) => {
    const classes = useStyle()
    const translate = useTranslate()
    const { irbTypeList } = useIRBType()

    const onChangeHomePhone = (form: FormApi<FormType, Partial<FormType>>, val: string) => {
        if (val) {
            form.change('telephone', val.replace(/[^\d]/g, '').slice(0, 20))
        }
    }

    return (
        <FinalForm onSubmit={onSubmit} initialValues={initialValues}>
            {({ handleSubmit, form, values }) => {
                if (onRefForm) onRefForm(form)
                return (
                    <Grid container className={classes.container}>
                        <Grid item xs={12}>
                            <MyTextfield
                                name="nameTH"
                                required
                                materialInputProps={{
                                    label: `${translate.get('UM.SETTINGREC.FORM.NAME_TH')}`,
                                    disabled: false,
                                    placeholder: `${translate.get('UM.SETTINGREC.FORM.NAME_TH')} ${translate.get(
                                        'LABEL.CAN_BE_FILL_ENG',
                                    )}`,
                                    size: 'small',
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <MyTextfield
                                name="nameEN"
                                required
                                materialInputProps={{
                                    label: `${translate.get('UM.SETTINGREC.FORM.NAME_EN')}`,
                                    disabled: false,
                                    placeholder: `${translate.get('UM.SETTINGREC.FORM.NAME_EN')}`,
                                    size: 'small',
                                }}
                                validates={[validateEN(translate.get('MESSAGE.M002'))]}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <MyTextfield
                                name="addressTH"
                                required
                                materialInputProps={{
                                    label: `${translate.get('UM.SETTINGREC.FORM.ADDRESS_TH')}`,
                                    disabled: false,
                                    placeholder: `${translate.get('UM.SETTINGREC.FORM.ADDRESS_TH')} ${translate.get(
                                        'LABEL.CAN_BE_FILL_ENG',
                                    )}`,
                                    size: 'small',
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <MyTextfield
                                name="addressEN"
                                required
                                materialInputProps={{
                                    label: `${translate.get('UM.SETTINGREC.FORM.ADDRESS_EN')}`,
                                    disabled: false,
                                    placeholder: `${translate.get('UM.SETTINGREC.FORM.ADDRESS_EN')}`,
                                    size: 'small',
                                }}
                                validates={[validateEN(translate.get('MESSAGE.M002'))]}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <MyTextfield
                                name="telephone"
                                required
                                materialInputProps={{
                                    label: `${translate.get('UM.SETTINGREC.FORM.TEL')}`,
                                    disabled: false,
                                    placeholder: `${translate.get('UM.SETTINGREC.FORM.TEL')}`,
                                    size: 'small',
                                }}
                                validates={[validatePhone(translate.get('MESSAGE.M003'))]}
                                handleValueChange={(val) => {
                                    onChangeHomePhone(form, val)
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <MyTextfield
                                name="email"
                                required
                                materialInputProps={{
                                    label: `${translate.get('UM.SETTINGREC.FORM.EMAIL')}`,
                                    disabled: false,
                                    placeholder: `${translate.get('UM.SETTINGREC.FORM.EMAIL')}`,
                                    size: 'small',
                                }}
                                validates={[validateEmail(translate.get('MESSAGE.M017'))]}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Grid item xs={12} sm={6} style={{ height: '105px' }}>
                                <Select
                                    required
                                    name="recID"
                                    option={irbTypeList}
                                    label={translate.get('UM.SETTINGREC.FORM.REC')}
                                    placeholder={translate.get('UM.SETTINGREC.FORM.REC')}
                                    size="small"
                                    defaultValue={initialValues?.recID ? [initialValues?.recID] : undefined}
                                    onChangeSelect={(val) => {
                                        if (onChangeREC) onChangeREC(Number(val) ?? null)
                                    }}
                                />
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <MyTextfield
                                name="headerCertificateTH"
                                required
                                materialInputProps={{
                                    label: `${translate.get('UM.SETTINGREC.FORM.HEADER_CERTIFICATE_TH')}`,
                                    disabled: false,
                                    placeholder: `${translate.get(
                                        'UM.SETTINGREC.FORM.HEADER_CERTIFICATE_TH',
                                    )} ${translate.get('LABEL.CAN_BE_FILL_ENG')}`,
                                    size: 'small',
                                }}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <MyTextfield
                                name="headerCertificateEN"
                                required
                                materialInputProps={{
                                    label: `${translate.get('UM.SETTINGREC.FORM.HEADER_CERTIFICATE_EN')}`,
                                    disabled: false,
                                    placeholder: `${translate.get('UM.SETTINGREC.FORM.HEADER_CERTIFICATE_EN')}`,
                                    size: 'small',
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <MyTextfield
                                name="headerMemorandumTH"
                                required
                                materialInputProps={{
                                    label: `${translate.get('UM.SETTINGREC.FORM.HEADER_MEMORANDUM_TH')}`,
                                    disabled: false,
                                    placeholder: `${translate.get(
                                        'UM.SETTINGREC.FORM.HEADER_MEMORANDUM_TH',
                                    )} ${translate.get('LABEL.CAN_BE_FILL_ENG')}`,
                                    size: 'small',
                                }}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <MyTextfield
                                name="headerMemorandumEN"
                                required
                                materialInputProps={{
                                    label: `${translate.get('UM.SETTINGREC.FORM.HEADER_MEMORANDUM_EN')}`,
                                    disabled: false,
                                    placeholder: `${translate.get('UM.SETTINGREC.FORM.HEADER_MEMORANDUM_EN')}`,
                                    size: 'small',
                                }}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <MyTextfield
                                name="organizationTH"
                                required
                                materialInputProps={{
                                    label: `${translate.get('UM.SETTINGREC.FORM.ORGANIZATION_TH')}`,
                                    disabled: false,
                                    placeholder: `${translate.get(
                                        'UM.SETTINGREC.FORM.ORGANIZATION_TH',
                                    )} ${translate.get('LABEL.CAN_BE_FILL_ENG')}`,
                                    size: 'small',
                                }}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <MyTextfield
                                name="organizationEN"
                                required
                                materialInputProps={{
                                    label: `${translate.get('UM.SETTINGREC.FORM.ORGANIZATION_EN')}`,
                                    disabled: false,
                                    placeholder: `${translate.get('UM.SETTINGREC.FORM.ORGANIZATION_EN')}`,
                                    size: 'small',
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} className={classes.buttonSection}>
                            <Grid container justify="flex-end" spacing={2}>
                                <Grid item>
                                    <Button
                                        size={'large'}
                                        variant="contained"
                                        className={classes.cancelButton}
                                        onClick={onClickBack}
                                    >
                                        {translate.get('BUTTON.CANCEL')}
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button
                                        size={'large'}
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSubmit}
                                        className={classes.saveButton}
                                        style={{ minWidth: '0px' }}
                                    >
                                        {translate.get('BUTTON.SAVE')}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                )
            }}
        </FinalForm>
    )
}

export default Form
const useStyle = makeStyles(() => ({
    container: {
        width: '100%',
    },
    cancelButton: {
        backgroundColor: '#FFFFFF',
        border: 'solid 1px #db5f8e',
    },
    saveButton: {
        border: 'solid 1px #db5f8e',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    },
    buttonSection: {
        marginTop: '15px',
    },
}))
